var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Row = exports.Header = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Statistics/index.js";

var Header = function Header(_ref) {
  var text = _ref.text,
      _ref$headlineStyles = _ref.headlineStyles,
      headlineStyles = _ref$headlineStyles === void 0 ? {} : _ref$headlineStyles;
  return _react.default.createElement(_Basic.View, (0, _extends2.default)({
    isFlex: true,
    mb: 1
  }, headlineStyles.container, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    bold: true
  }, headlineStyles.text, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 9
    }
  }), (0, _i18n.default)("statistic_entries." + text)));
};

exports.Header = Header;

var Row = function Row(_ref2) {
  var label = _ref2.label,
      home = _ref2.home,
      away = _ref2.away,
      _ref2$rowStyles = _ref2.rowStyles,
      rowStyles = _ref2$rowStyles === void 0 ? {} : _ref2$rowStyles,
      even = _ref2.even;
  return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
    p: 2,
    evenly: true,
    bg: even ? rowStyles.evenBg || '' : rowStyles.oddBg || ''
  }, rowStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.Text, {
    bold: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  }, home), _react.default.createElement(_Basic.Text, {
    numberOfLines: 1,
    px: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }, (0, _i18n.default)("statistic_entries." + label)), _react.default.createElement(_Basic.Text, {
    bold: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, away));
};

exports.Row = Row;

var Statistics = function Statistics(_ref3) {
  var label = _ref3.label,
      data = _ref3.data,
      rowStyles = _ref3.rowStyles,
      headlineStyles = _ref3.headlineStyles,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["label", "data", "rowStyles", "headlineStyles"]);
  return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
    mb: 2
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }), label ? _react.default.createElement(Header, (0, _extends2.default)({
    text: label
  }, {
    headlineStyles: headlineStyles
  }, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 18
    }
  })) : null, data ? data.map(function (item, index) {
    return _react.default.createElement(Row, (0, _extends2.default)({
      key: "statistic_" + item.label,
      even: index % 2 === 0,
      rowStyles: rowStyles
    }, item, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 19
      }
    }));
  }) : null);
};

Statistics.propTypes = {
  label: _propTypes.default.string,
  data: _propTypes.default.instanceOf(Array).isRequired,
  rowStyles: _propTypes.default.object,
  headlineStyles: _propTypes.default.object,
  headlineTextStyles: _propTypes.default.object
};
Statistics.defaultProps = {
  headlineStyles: {
    container: {
      justifyContent: 'center'
    }
  },
  rowStyles: {
    borderX: 1,
    borderY: 1,
    borderColor: 'border.main',
    mb: 2
  }
};
var _default = Statistics;
exports.default = _default;